import { Box, Progress, Text } from '@chakra-ui/react'

import { useMatchEventEditorData } from '@queries/useMatchEventEditorData'

export function DeleteAllEventsProgress() {
    const { isRemovingAll, deleteAllProgress } = useMatchEventEditorData()

    if (!isRemovingAll || !deleteAllProgress || deleteAllProgress.total === 0) {
        return null
    }

    const label = `Deleting events (${deleteAllProgress.completed} of ${deleteAllProgress.total})…`

    return (
        <Box mb={2}>
            <Text fontSize="sm" color="gray.600" mb={1}>
                {label}
            </Text>
            <Progress
                size="xs"
                value={(deleteAllProgress.completed / deleteAllProgress.total) * 100}
                aria-label={label}
            />
        </Box>
    )
}
